export default __webpack_public_path__ + "690f5523ccdfa59875156c6bcc6a7c0c.svg";